import { render, staticRenderFns } from "./Fund-TradingInfo.vue?vue&type=template&id=05a31e02&scoped=true&"
import script from "./Fund-TradingInfo.vue?vue&type=script&lang=js&"
export * from "./Fund-TradingInfo.vue?vue&type=script&lang=js&"
import style0 from "./Fund-TradingInfo.vue?vue&type=style&index=0&id=05a31e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a31e02",
  null
  
)

export default component.exports